import {request} from "./request";
// 核心产品类型列表
export function getTypeName(coreProductTypeId) {
  return request({
    url:'/coreProduct/typeList',
    method:'get',
    params: { coreProductTypeId: coreProductTypeId} // 如果没有提供parentId，则默认为0
  })
}
// export function getTypeName(coreProductTypeName) {
//   return request({
//     url:'/coreProduct/typeList',
//     method:'get',
//     params: { coreProductTypeName: coreProductTypeName || ''} 
//   })
// }

export function getTypeList(parentId) {
  return request({
    url:'/coreProduct/typeList',
    method:'get',
    params: { parentId: parentId || 0} // 如果没有提供parentId，则默认为0
  })
}


// 核心产品列表
export function getCoreProductList(data) {
  return request({
    url:'/coreProduct/list',
    method:'get',
    params: data,
  })
}

// 核心产品详情
export function getCoreProductDetails(data) {
  return request({
    url:'/coreProduct/'+data,
    method:'get',
  })
}
// 客户案例
export function getProductServiceTypeList(data) {
  return request({
    url:'/productServiceType/list',
    method:'get',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/network/v2revision.js